import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { PATH_BU_PPT_RELATORIOS } from 'services/rotasp/path';
import { RequestConsultaReimpressaoFic, Types } from './types';

import { baixarArquivosRequest } from '../../utils/arquivos/baixarArquivos/actions';
// ACTIONS
import {
	consultaReimpressaoFicSuccess,
	consultaReimpressaoFicFailure,
} from './actions';

function* consultaReimpressaoFicRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: RequestConsultaReimpressaoFic } = request;

	const { usuario, ...params } = payload;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_BU_PPT_RELATORIOS,
		`fic`,
		params,
		undefined,
		undefined,
		undefined,
		usuario,
		undefined,
	);

	if (response.status === 200) {
		yield put(consultaReimpressaoFicSuccess(response.data));
		if (response.data) {
			yield put(
				baixarArquivosRequest(token || '', {
					url: response.data.pdfDataUrl,
					instanceRequest: 'iirgd-protocolo',
				}),
			);
		}
	} else {
		yield put(consultaReimpressaoFicFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_REIMPRESSAO_FIC_REQUEST,
		consultaReimpressaoFicRequest,
	),
]);
